import config from 'config';
import { fetchData, IFetchDataResponse } from 'framework/api/fetch-data';
import { AuthorizationClaims, ensureClaims, UserAccessRights } from 'framework/authorization';
import { gb } from 'growthbook/initGrowthBook';
import { GB_KEYS } from 'growthbook/growthbook.keys';
import { DeliveryIntegrationProviders, FeatureState, DeliveryIntegrationProviderNames } from './types';

export const isZetesIntegrationEnabled = async (
  providers: IFetchDataResponse<DeliveryIntegrationProviders, any> | undefined,
): Promise<FeatureState> => {
  const userHasAccess = ensureClaims({
    [AuthorizationClaims.ORDERMANAGEMENT_DELIVERYINTEGRATION]: UserAccessRights.Read,
  });

  if (!userHasAccess) {
    return {
      isEnabled: false,
    };
  }

  // WYN-63927: when the GrowthBook flag is ON, surface the Zetes Failed Submissions
  // menu regardless of the DI gateway being online. This allows legacy orders to
  // still be remediated after the DI provider is decommissioned.
  if (gb.isOn(GB_KEYS.ZETES_FAILED_SUBMISSIONS_ENABLED)) {
    return {
      isEnabled: true,
    };
  }

  if (providers?.data?.deliveryProviders?.find(
    (provider) => provider.providerName.toLowerCase() === DeliveryIntegrationProviderNames.ZetesIntegration,
  )) {
    const result = await fetchData<{ enabled: boolean }>({
      url: config.apiEndpoints.zetesIntegration.checkEnabled,
    });
    return {
      isEnabled: result.data?.enabled && !!result.data,
    };
  }
  return {
    isEnabled: false,
  };
};
